import { executeDictionaryLoop } from '../dictionary-loop';

/**
 * Fan-Out Engine specifically for Dictionary-related complex queries.
 * Example: "How do I speak like a Zoomer?" or "Explain the history of the word Rizz."
 */
export async function executeDictionaryFanOut(seedPrompt: string): Promise<string> {
    console.log(`[Dictionary Fan-Out] Expanding prompt: "${seedPrompt}"`);
    
    // Generate sub-queries specific to dictionary contexts
    const subQueries = [
        "What are the top 3 most popular trending slang words right now?",
        "What is the definition and origin of the key terms mentioned?",
        "Are there any contextual examples of these words being used in a sentence?"
    ];
    
    let masterContextBlock = `\n[SYSTEM HARNESS CONTEXT: DICTIONARY FAN-OUT RESEARCH ACTIVATED.]\n`;

    for (const query of subQueries) {
        const data = await executeDictionaryLoop(query);
        if (data) {
            masterContextBlock += `\n--- Sub-Query: ${query} ---\n${data}\n`;
        }
    }

    return masterContextBlock;
}
